export const TOGGLE_LOADING = 'admin/studentType/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'admin/studentType/TOGGLE_SUCCESS'
export const GET_STUDENT_TYPES = 'admin/studentType/GET_STUDENT_TYPES'
export const SET_STUDENT_TYPES = 'admin/studentType/SET_STUDENT_TYPES'
export const CREATE_STUDENT_TYPE = 'admin/studentType/CREATE_STUDENT_TYPE'
export const DELETE_STUDENT_TYPE = 'admin/studentType/DELETE_STUDENT_TYPE'
export const SET_REMOVED_STUDENT_TYPE = 'admin/studentType/SET_REMOVED_STUDENT_TYPE'
export const SET_CREATED_STUDENT_TYPE = 'admin/studentType/SET_CREATED_STUDENT_TYPE'
